import { useApiClient } from '../client.js'

export const GET_EXPERIMENT_VARIANTS_WITH_RELATION_ID_ENDPOINT = '/core/v2/experiment/{experimentName}/experiment_variant/{relationId}'

export function getExperimentVariantWithRelationId (relationId, experimentName) {
  const apiClient = useApiClient()

  return apiClient.get({
    url: GET_EXPERIMENT_VARIANTS_WITH_RELATION_ID_ENDPOINT,
    urlParams: {
      relationId,
      experimentName,
    },
  })
}
